module.exports = __webpack_public_path__ + "static/logos_web-714d3aa2280c1138b993ecdfed254f84.jpg";